export var getBaseUrl = function (baseUrl, marketLocale, id, siteContext) {
    var baseApiUrl = id
        ? baseUrl + "api/v1/responses/" + id
        : baseUrl + "api/v1/responses?marketLocale=" + marketLocale + "&siteContext=" + siteContext;
    return baseApiUrl;
};
